import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feccf11a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "datastore-hint" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "datastore-hint margin-top-10" }
const _hoisted_4 = {
  key: 0,
  class: "margin-top-10"
}
const _hoisted_5 = ["href", "download"]

import { onUnmounted, ref } from "vue";
import { ElButton, ElDialog, ElProgress } from "element-plus";
import { TYPE } from "vue-toastification";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { DataStoreJob, DataStoreTable } from "@/datastore/types";
import {
  downloadExport,
  getJob,
  startExport,
} from "@/datastore/services/datastore.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportDialog',
  props: {
    table: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

const props = __props;
const emit = __emit;

const job = ref<DataStoreJob | null>(null);
const downloadUrl = ref<string | null>(null);
const downloadName = ref("export.csv");
let pollTimer: ReturnType<typeof setInterval> | null = null;

function formatCount(n: number): string {
  return n.toLocaleString("en-US");
}

async function startExportJob() {
  try {
    job.value = await startExport(props.table.id);
    pollTimer = setInterval(async () => {
      if (!job.value) return;
      job.value = await getJob(job.value.id);
      if (job.value.state === "FINISHED") {
        stopPolling();
        const blob = await downloadExport(job.value.id);
        revokeUrl();
        downloadUrl.value = URL.createObjectURL(blob);
        downloadName.value = `${props.table.name
          .replace(/\W+/g, "_")
          .toLowerCase()}.csv`;
        showAlert(TYPE.SUCCESS, t("DataStore.ExportReady"));
      } else if (job.value.state === "FAILED") {
        stopPolling();
        showAlert(TYPE.ERROR, job.value.error ?? t("Common.UnknownError"));
      }
    }, 450);
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  }
}

function stopPolling() {
  if (pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
}

function revokeUrl() {
  if (downloadUrl.value) {
    URL.revokeObjectURL(downloadUrl.value);
    downloadUrl.value = null;
  }
}

function close() {
  emit("update:modelValue", false);
}

function onVisibilityChange(visible: boolean) {
  emit("update:modelValue", visible);
  if (!visible) {
    stopPolling();
    job.value = null;
    revokeUrl();
  }
}

onUnmounted(() => {
  stopPolling();
  revokeUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    "model-value": _ctx.modelValue,
    title: _unref(t)('DataStore.ExportTable', { name: _ctx.table.name }),
    width: "480px",
    "custom-class": "datastore-dialog",
    "append-to-body": "",
    "destroy-on-close": "",
    "close-on-click-modal": false,
    "onUpdate:modelValue": onVisibilityChange
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(ElButton), {
        id: "datastore-export-close",
        class: "btn-oneTeg3",
        size: "small",
        onClick: close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("Common.Close")), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(ElButton), {
        id: "datastore-export-start",
        class: "btn-oneTeg2",
        size: "small",
        disabled: !!job.value && job.value.state === 'RUNNING',
        onClick: startExportJob
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("DataStore.StartExport")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)("DataStore.ExportScope", { rows: formatCount(_ctx.table.rowCount) })), 1),
      (job.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(ElProgress), {
              percentage: job.value.progressPercentage,
              "stroke-width": 10
            }, null, 8, ["percentage"]),
            _createElementVNode("div", _hoisted_3, _toDisplayString(formatCount(job.value.processedRows)) + " / " + _toDisplayString(formatCount(job.value.totalRows)) + " " + _toDisplayString(_unref(t)("DataStore.Rows").toLowerCase()) + " · " + _toDisplayString(job.value.state), 1),
            (downloadUrl.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("a", {
                    id: "datastore-export-download",
                    class: "el-button el-button--small btn-oneTeg2 datastore-download-link",
                    href: downloadUrl.value,
                    download: downloadName.value
                  }, _toDisplayString(_unref(t)("DataStore.Download")), 9, _hoisted_5)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})